module.exports = __webpack_public_path__ + "static/img/2_2_1.ff1144ce.jpg";